// extracted by mini-css-extract-plugin
export default {"filtersContainer":"Filters_filtersContainer__YfKxd","filterSetting":"Filters_filterSetting__fBicb","icon":"Filters_icon__7cIDn"};